import Core from './Core.component';
import * as error from './error';
import * as config from './config';
import * as locales from './locales';
import * as session from './session';
import * as notification from './notification';
export { error, config, locales, session, notification };
export default Core;
